import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px'
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.neutrals.beige3}`,
  paddingTop: '24px'
}));
